export const PROFILE_CORRECTION_ACADEMIC_FIELDS = {
  startDate: 'academicExperienceStarted',
  awardDate: 'academicExperienceAwarded',
  award: 'award',
  specialisation: 'specialisation',
  prevDegreeFile: 'prevDegreeFile',
  transcriptFile: 'transcriptFile',
} as const;

export type ProfileCorrectionAcademicKey = keyof typeof PROFILE_CORRECTION_ACADEMIC_FIELDS;

const PROFILE_CORRECTION_FIELD_NAMES: ReadonlySet<string> = new Set([
  'phone',
  'salutation',
  'gender',
  'dateOfBirth',
  'nationality',
  'countryOfBirth',
  'residenceUKFile',
  'photoIdFile',
  'visaCode',
  'visaFile',
  'addressLine1',
  'addressLine2',
  'city',
  'postcode',
  'country',
  'emergencyFirstName',
  'emergencyLastName',
  'emergencyPhone',
  'emergencyRelationship',
  ...Object.values(PROFILE_CORRECTION_ACADEMIC_FIELDS),
  'cvFile',
  'motivationLetter',
  'howDidYouHearAboutTheCollege',
  'supportingStatement',
  'additionalNeeds',
  'englishLevel',
  'englishLevelFile',
]);

export const isProfileCorrectionField = (name: string) => PROFILE_CORRECTION_FIELD_NAMES.has(name);
